import { createReducer } from '@reduxjs/toolkit'

import { Notification, NotificationCount } from '@/model/notification'
import { updateOrAddArray } from '@/utils/draft'

import {
  markNotificationsAsRead,
  notificationNamespace,
  NotificationsResponse,
  readAllNotifications,
  readNotificationCount,
  upsertNewNotification,
} from './notification-actions'

const initialState: {
  notificationMap: Record<number, Notification[] | undefined>,
  notificationCountMap: Record<number, NotificationCount | undefined>,
  notificationResponseMap: Record<number, Record<string, NotificationsResponse | undefined> | undefined>
} = {
  notificationMap: {},
  notificationCountMap: {},
  notificationResponseMap: {},
}

const reducer = createReducer(initialState, (builder) => {
  builder.addCase(readAllNotifications.fulfilled, (draft, { payload, meta: { arg } }) => {
    const { creatorId, type, nextId } = arg
    const { list } = payload
    const existingNotifications = draft.notificationMap[creatorId] ?? []

    const existResponse = draft.notificationResponseMap[creatorId]
    draft.notificationResponseMap[creatorId] = {
      ...existResponse,
      ...{ [`${type}`]: { ...payload, list: [] } },
    }

    const isReload = nextId === undefined
    const source = isReload ? existingNotifications : list
    const target = isReload ? list : existingNotifications
    updateOrAddArray(source, target)
    draft.notificationMap[creatorId] = target
  })

  builder.addCase(readNotificationCount.fulfilled, (draft, { payload, meta: { arg } }) => {
    draft.notificationCountMap[arg.creatorId] = payload
  })

  builder.addCase(markNotificationsAsRead.fulfilled, (draft, { payload, meta: { arg } }) => {
    const existCountMap = draft.notificationCountMap[arg.creatorId]
    draft.notificationCountMap[arg.creatorId] = {
      ...existCountMap,
      ...payload,
    }
  })

  builder.addCase(upsertNewNotification, (draft, { payload }) => {
    const { creatorId, notification } = payload
    const existNotificationResponse = draft.notificationResponseMap[creatorId]

    // Do not upsert if notification has never been loaded
    if (existNotificationResponse?.[notification.type] !== undefined) {
      const draftNotifications = draft.notificationMap[creatorId] ?? []
      const target = [notification]
      updateOrAddArray(draftNotifications, target)
      draft.notificationMap[creatorId] = target
    }
  })
})

export default { [notificationNamespace]: reducer }
